import React from 'react'
import { IconProps } from '../types'

export default function MonitorIcon({
    className = 'h-[32px] w-[32px]',
    fill = 'black',
    fillOpacity = '0.4',
    ...props
}: IconProps) {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.9375 24.7917C10.6795 24.7917 7.00117 24.6408 4.69271 24.497C2.40054 24.3546 0.536208 22.6539 0.319458 20.3178C0.153 18.5286 0 15.9233 0 12.3958C0 8.86833 0.153 6.26308 0.31875 4.47454C0.536208 2.13775 2.40054 0.437042 4.69271 0.294667C7.00117 0.150875 10.6795 0 15.9375 0C21.1955 0 24.8738 0.150875 27.1823 0.294667C29.4745 0.437042 31.3388 2.13775 31.5555 4.47383C31.722 6.26308 31.875 8.86833 31.875 12.3958C31.875 15.9233 31.722 18.5286 31.5562 20.3171C31.3388 22.6539 29.4745 24.3546 27.1823 24.497C24.8738 24.6408 21.1955 24.7917 15.9375 24.7917ZM15.9375 26.9167C14.6512 26.9162 13.456 26.9079 12.3519 26.8919L12.1996 28.1102C12.1677 28.3673 12.0429 28.6038 11.8488 28.7753C11.6547 28.9469 11.4047 29.0416 11.1456 29.0417H9.12687C8.76685 29.0416 8.41592 29.1548 8.12388 29.3653C7.83183 29.5759 7.61349 29.873 7.49983 30.2147C7.43648 30.4043 7.41914 30.6063 7.44924 30.804C7.47934 31.0017 7.55603 31.1893 7.67297 31.3515C7.78991 31.5137 7.94375 31.6458 8.12179 31.7368C8.29983 31.8278 8.49696 31.8752 8.69692 31.875H23.1788C23.3787 31.8752 23.5759 31.8278 23.7539 31.7368C23.932 31.6458 24.0858 31.5137 24.2027 31.3515C24.3197 31.1893 24.3964 31.0017 24.4265 30.804C24.4566 30.6063 24.4392 30.4043 24.3759 30.2147C24.2622 29.8729 24.0437 29.5757 23.7515 29.3651C23.4594 29.1546 23.1083 29.0414 22.7481 29.0417H20.7294C20.4705 29.0416 20.2205 28.947 20.0264 28.7756C19.8323 28.6042 19.7075 28.3678 19.6754 28.1109L19.5231 26.8919C18.419 26.9079 17.2238 26.9162 15.9375 26.9167Z"
                fill={fill}
                fillOpacity={fillOpacity}
            />
        </svg>
    )
}
